module.exports = __webpack_public_path__ + "img/interview1.eddd558a.png";